import { Component, OnInit,  HostListener } from '@angular/core';
import { EventService } from '../../services/event.service';
import { JqueryUtils } from '../../utils/jquery.utils';
import { Router } from '@angular/router';
import { CONSTANTS } from '../../constants';
import { LoginService } from '../../services/api/login.service';
import { NotificationService } from '../../services/notification.service';
import { UtilityService } from '../../services/utility.service';
import * as $ from 'jquery';
import { StrategyService } from '../../services/api/strategy.service';
import { SocketService } from '../../services/socket.service';
import { DataService } from '../../services/data.service';
import { ChannelService } from '../../services/api/channel.service';

@Component({
  selector: 'app-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss']
})

export class WrapperComponent implements OnInit {
  alertText = '';
  ref: any;
  orders_map: any = {};
  position_datas = {};
  dd = 0;
  admin: any;
  username: any;
  partner: any;
  IsStrategyAvai: any;
  IsStrategyAvai1: any;
  strategyConfig = [];
  public innerWidth: any;

  constructor(private ls: LoginService,
    private channelService: ChannelService,
    private dataService: DataService,
    private ns: NotificationService, private jq: JqueryUtils,
    private us: UtilityService, private router: Router,
    private es: EventService, private as: StrategyService,
    private socketService: SocketService) { }

  ngOnInit() {

    this.username = sessionStorage.getItem(CONSTANTS.COOKIE.USERNAME);
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    let details = this.dataService.retrieveLiveSocketDetails();
    if (details) {
      this.socketService.init_connection();
    } else {
      this.channelService.getConnectionDetails().subscribe((response: any) => {
        this.dataService.saveLiveSocketDetails(response.pnl_channel_connection);
        this.socketService.init_connection();
      });
    }

    $("#LightTheme").on("click", function() {
      $("html").attr("class", "light-theme")
    }),

    $("#DarkTheme").on("click", function() {
      $("html").attr("class", "dark-theme")
    }),

    $("#SemiDarkTheme").on("click", function() {
      $("html").attr("class", "semi-dark")
    }),

    $("#MinimalTheme").on("click", function() {
      $("html").attr("class", "minimal-theme")
    })


    $("#headercolor1").on("click", function() {
      $("html").addClass("color-header headercolor1"), $("html").removeClass("headercolor2 headercolor3 headercolor4 headercolor5 headercolor6 headercolor7 headercolor8")
    }), $("#headercolor2").on("click", function() {
      $("html").addClass("color-header headercolor2"), $("html").removeClass("headercolor1 headercolor3 headercolor4 headercolor5 headercolor6 headercolor7 headercolor8")
    }), $("#headercolor3").on("click", function() {
      $("html").addClass("color-header headercolor3"), $("html").removeClass("headercolor1 headercolor2 headercolor4 headercolor5 headercolor6 headercolor7 headercolor8")
    }), $("#headercolor4").on("click", function() {
      $("html").addClass("color-header headercolor4"), $("html").removeClass("headercolor1 headercolor2 headercolor3 headercolor5 headercolor6 headercolor7 headercolor8")
    }), $("#headercolor5").on("click", function() {
      $("html").addClass("color-header headercolor5"), $("html").removeClass("headercolor1 headercolor2 headercolor4 headercolor3 headercolor6 headercolor7 headercolor8")
    }), $("#headercolor6").on("click", function() {
      $("html").addClass("color-header headercolor6"), $("html").removeClass("headercolor1 headercolor2 headercolor4 headercolor5 headercolor3 headercolor7 headercolor8")
    }), $("#headercolor7").on("click", function() {
      $("html").addClass("color-header headercolor7"), $("html").removeClass("headercolor1 headercolor2 headercolor4 headercolor5 headercolor6 headercolor3 headercolor8")
    }), $("#headercolor8").on("click", function() {
      $("html").addClass("color-header headercolor8"), $("html").removeClass("headercolor1 headercolor2 headercolor4 headercolor5 headercolor6 headercolor7 headercolor3")
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
    if(innerWidth <= 700){
      $("#wrapper").removeClass('toggled');
    }else{
      $("#wrapper").removeClass('toggled');
    }

  }

  onAppEvent() {
    this.subscribeEvents();
  }

  subscribeEvents() {
    // this.ss.onOrderUpdate().subscribe((msg: any) => {
    //   this.orders_map[msg.data.orders[0].account._id] = msg.data.orders;
    //   this.sendOrderUpdate();
    // });
    // this.ss.onPositionUpdate().subscribe((msg: any) => {
    //   this.position_datas = msg.data;
    //   this.sendPositionUpdate();
    // });
    // this.ss.onDDUpdate().subscribe((msg: any) => {
    //   this.dd = msg.data;
    //   this.sendDDUpdate();
    // });
  }

  sendDDUpdate() {
    if (this.ref.name && (this.ref.name.toLowerCase() == 'dashboard')) {
      this.ref.onDDUpdate(this.dd);
    }
  }

  navigate() { }

  onActivate(ref: any) {
    this.ref = ref;
  }

  ngOnDestroy() {
   this.socketService.close_connection();
  }

  Confirmlogout() {
    this.ls.logout().subscribe((response: any) => {
      if (response.response_code == 1000) {
        sessionStorage.clear();
        this.us.removeAllCookies();
        this.onModalClose();
        this.ns.showAlert(CONSTANTS.SUCCESS, "Logged out successfully");
        this.router.navigate(['']);
      }
    });
  }
  logout() {
    this.jq.openModal('LogoutModal');
  }

  onModalClose() {
    this.jq.closeModal('LogoutModal');
  }

  route(menu: any) {
    if (menu == "users") {
      this.router.navigate(['/admin', 'users']);
    } else if (menu == "accounts") {
      this.router.navigate(['/admin', 'brokers']);
    } else if (menu == "settings") {
      this.router.navigate(['/admin', 'settings']);
    } else if (menu == "dashboard") {
      this.router.navigate(['/admin', 'dashboard']);
    } else if (menu == "live") {
      this.router.navigate(['/admin', 'live']);
    } else if (menu == "tutorial") {
      this.router.navigate(['/admin', 'tutorial']);
    } else if (menu == "reset") {
      this.router.navigate(['/admin', 'resetpass']);
    } else if (menu == "channel") {
      this.router.navigate(['/admin', 'channel']);
    } else if (menu == "settings") {
      this.router.navigate(['/admin', 'settings']);
    } else if (menu == "logs") {
      this.router.navigate(['/admin', 'logs']);
    }else if (menu == "partner") {
      this.router.navigate(['/admin', 'partner']);
    }else if (menu == "partner-live") {
      this.router.navigate(['/admin', 'partner-live']);
    }
  }
}

